import { Component, Vue, Prop as prop} from 'nuxt-property-decorator';
import { CatalogFilterField } from '~/types/catalog';

interface IRangeOption {
    value: [number, number];
    label: string;
}


@Component({
    components: {
       rangeSlider: require('~/components/form/range/').default,
       checkbox: require('~/components/form/checkbox-field/').default,
    },
})
export default class CatalogSliderFilterComponent extends Vue {

    @prop()
    public value: CatalogFilterField;

    @prop()
    public opened: boolean;

    get labelClass() {
        if (this.value.code === 'price') {
            return 'currency';
        }

        return '';
    }
    
    get changed() {
        return this.value.values[0] > this.value.bounds[0] || this.value.values[1] < this.value.bounds[1];
    }

    get options() {
        if (!this.value.options || this.value.options.length < 3) {
            return null;
        }

        let start = this.value.bounds![0];

        const result: IRangeOption[] = [];
        
        this.value.options.forEach((e, i) => {

            let label = '';
            if (!i) {
                label = `До ${e.toMoney()} ${this.value.suffix ?? ''}`;
            } else if (i === this.value.options!.length - 1) {
                label = `${start.toMoney()} ${this.value.suffix ?? ''} и дороже`;
            } else {
                label = `${start.toMoney()} - ${e.toMoney()} ${this.value.suffix ?? ''}`;
            }

            result.push({
                label,
                value: [start, e],
            });

            start = e;
        })

        return result;
    }

    public apply(option: IRangeOption) {
        this.value.values = option.value;
    }
}
